/**
 * lsgo-authentication URLs per environment — same hostname switch as the other
 * service URLs (config/axios.js): *-staging.lifeskillsgo.com → staging,
 * *.lifeskillsgo.com → production, anything else → local dev.
 *
 * The base URL is also the token issuer, so it must match lsgo-authentication's
 * ISSUER exactly (local: "localhost", not 127.0.0.1). Each redirect URI must be
 * registered on the lsgo-student-web client in that environment.
 */
const { hostname } = window.location;
const isLifeskills = hostname.includes('lifeskillsgo.com');
const isStagingHost = isLifeskills && hostname.includes('-staging');

export const LSGO_AUTHENTICATION_BASE_URL = isLifeskills
    ? isStagingHost
        ? 'https://auth-staging.lifeskillsgo.com'
        : 'https://auth.lifeskillsgo.com'
    : 'http://localhost:3006';

export const LSGO_AUTHENTICATION_CLIENT_ID = 'lsgo-student-web';

export const LSGO_AUTHENTICATION_REDIRECT_URI = isLifeskills
    ? isStagingHost
        ? 'https://student-staging.lifeskillsgo.com/auth/callback'
        : 'https://student.lifeskillsgo.com/auth/callback'
    : 'http://localhost:3001/auth/callback';
